import { createSelector } from 'reselect'
import featureScopesSelector from './feature-scope/featureScopesSelector'

const e3dForceWltpDataUpdateSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dForceWltpDataUpdate'),
)

export default e3dForceWltpDataUpdateSelector
